import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarAdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-width:1.5px;}.a{stroke-linecap:round;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "calendar-add" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 13.5,
			x2: 12,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9,
			y1: 16.5,
			x2: 15,
			y2: 16.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "b",
			x: .75,
			y: 3.75,
			width: 22.5,
			height: 19.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "b",
			x1: .75,
			y1: 9.75,
			x2: 23.25,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 6,
			x2: 6.75,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 6,
			x2: 17.25,
			y2: .75
		})
	]
});
export default SvgCalendarAdd;
